import { Injectable } from '@angular/core';
import { ParentService } from '../ParentClass/ParentService';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../../app.constants';
import { BehaviorSubject } from 'rxjs';

declare var jQuery: any;
declare var signalR: any;

type hubChannel = 'schedule' | 'dispatch' | 'liveMap' | 'fax' | 'editReservation';

@Injectable()
export class SignalrScheduleService extends ParentService {
  private connection: any;
  private proxy: any;
  private start: any;
  private pointer: any;

  private hubConnectionReadySubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public hubConnectionReady$: Observable<boolean> = this.hubConnectionReadySubject.asObservable();

  constructor(protected http: Http) {
    super();
    this.connection = jQuery.hubConnection(constant.SERVER_WITH_SIGNALR);
    this.proxy = this.connection.createHubProxy('trip2Driver');
    this.connection.start().done(() => this.declareHubConnectionAsReady());
  }

  private declareHubConnectionAsReady(): void {
    this.hubConnectionReadySubject.next(true);
  }

  getProxies(channel) {
    return this.proxy;
  }

  /**
   * @name activateSignal
   * @description
   * @param pointer
   */
  public activateSignal(pointer) {
    this.pointer = pointer;
  }

  /**
   * @name proxyListenSchedule
   * @description
   */
  public proxyListenSchedule() {
    return this.proxy;
  }

  public getProxy() {
    return this.proxy;
  }

  /**
   * @name connectionStart
   * @description
   */
  public connectionStart() {
    this.connection.start()
      .done(
        (data) => this.returnStart(data)
      );
  }

  /**
   * @name getConnection
   * @description
   */
  public getConnection() {
    return this.connection;
  }

  /**
   * @name stopConnection
   * @description
   */
  public stopConnection() {
    this.unsubscribe(this.connection)
      .subscribe(
        data => {
          this.connection.stop();
        }
      );
  }

  /**
   * @name returnStart
   * @description
   * @param data
   */
  public returnStart(data) {
    this.queryService(data)
      .subscribe(
        (success) => { },
      );
  }

  /**
   * @name queryService
   * @description
   * @param data
   */
  private buildServiceUrl(hub: hubChannel): string {
    const urls = {
      schedule: constant.URL_HUB_SERVICE_SCHEDULING,
      dispatch: constant.URL_HUB_SERVICE_DISPATCH,
      liveMap: constant.URL_HUB_SERVICE_LIVE_MAP,
      fax: constant.URL_HUB_FAX,
      editReservation: constant.URL_HUB_EDIT_RESERVATION,
    };

    return urls[hub] ? urls[hub] + this.connection.id : '';
  }

  public queryService(hub: hubChannel) {
    const serviceUrl = this.buildServiceUrl(hub);
    const bodyString = '';

    return this.http
      .post(serviceUrl, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public removeToSignalRGroup(hub: hubChannel) {
    const serviceUrl = this.buildServiceUrl(hub);

    return this.http
      .delete(serviceUrl, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public joinToEditReservationTripIdChannel(tripId: number) {
    const signalUrl = `${this.buildServiceUrl('editReservation')}/${tripId}`;

    return this.http
      .post(signalUrl, null, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public leaveEditReservationTripIdChannel(tripId: number) {
    const signalUrl = `${this.buildServiceUrl('editReservation')}/${tripId}`;

    return this.http
      .delete(signalUrl, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()))
  }
  
  /**
   * @name unsubscribe
   * @description
   * @param data
   */
  public unsubscribe(data) {
    let serviceUrl = '';
    if (this.pointer === 'editreservation') {
      serviceUrl = constant.URL_HUB_EDIT_RESERVATION + data.id;
    } else {
      serviceUrl = constant.URL_HUB_SERVICE_DISPATCH + data.id;
    }

    return this.http
      .delete(serviceUrl, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/signal-r/signalr-schedule.service.ts